export const PP_WEBAPP_APP_ID = 1;

export const PP_WEBAPP_APP_HOST = {
  devint: 'https://portal-devint.kareo.com',
  prod: 'https://portal.kareo.com',
  prodlas: 'https://portal.kareo.com',
  stage: 'https://stg-portal.kareo.com',
  test: 'https://portal-qa.kareo.com',
};

const portalConfig = {
  AppId: PP_WEBAPP_APP_ID,
  host: env => PP_WEBAPP_APP_HOST[env],
  requestProps: {
    dataType: 'json',
    headers: { 'Content-Type': 'application/json' },
  },
};

export default portalConfig;
